var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hello"},[_c('el-button',{attrs:{"type":"primary","plain":""},on:{"click":function($event){return _vm.getPdf('#DomPdf')}}},[_vm._v("下载")]),_c('div',{staticStyle:{"width":"100%","height":"auto"},attrs:{"id":"DomPdf"}},[(_vm.get_data)?_c('Graphics',{attrs:{"value":_vm.value}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }